import Swiper from "swiper";
import { Pagination, Navigation, A11y } from "swiper/modules";

const heroSlider = ($) => {
	const slidesCount = document.querySelectorAll(
		"#js-hero-slider .swiper-slide"
	).length;

	if (!slidesCount) return;

	// function that updates the titles so that the active title is always the first element in the progressbar container
	const updateTitlePosition = (activeSlideIndex) => {
		const progressBar = document.querySelector(
			".swiper-pagination--desktop.hero__slider__controls__progressbar"
		);
		const titles = document.querySelectorAll(".swiper-pagination-bullet");

		let offset;

		titles.forEach((span, index) => {
			if (index === activeSlideIndex) {
				offset = span.offsetLeft;
			}
		});

		progressBar.style.left = `-${offset}px`;
		progressBar.style.transition = "left 0.5s ease-out";

		// removing the transition property after the animation completes
		setTimeout(() => {
			progressBar.style.transition = "";
		}, 500);
	};

	// function that updates the fraction inside the progressbar on desktop
	const setFraction = (activeSlide, totalSlides, current) => {
		$(".activeslide").html(activeSlide + 1);
		$(".totalslide").html(totalSlides - 2);

		var fragment = document.querySelector(
			".hero__slider__controls__left__page-count"
		);

		if (current > totalSlides) current = 1;
		var idx = current;
		var tdx = totalSlides;

		// Update the numerator and denominator spans
		fragment.querySelector(".numerator").innerHTML = idx;
		fragment.querySelector(".denominator").innerHTML = tdx;
	};

	new Swiper("#js-hero-slider", {
		modules: [Pagination, Navigation, A11y],
		a11y: {
			prevSlideMessage: "Previous slide",
			nextSlideMessage: "Next slide",
		},
		direction: "horizontal",
		loop: slidesCount > 1,
		freeMode: false,
		observer: true,
		observeParents: true,
		centeredSlides: false,
		watchOverflow: true,

		on: {
			slideChange: function () {
				let activeSlide = this.realIndex;
				let totalSlides = this.slides.length;
				let current = this.realIndex + 1;

				if (window.innerWidth >= 1024) {
					setFraction(activeSlide, totalSlides, current);
				}

				// Update the title position inside progressBar
				updateTitlePosition(activeSlide);

				// Adjust arrow opacities based on the active slide
				let leftButtonContainer = document.querySelector(".swiper-button-prev");
				let rightButtonContainer = document.querySelector(
					".swiper-button-next"
				);

				let leftButton = leftButtonContainer.querySelector("button");
				let rightButton = rightButtonContainer.querySelector("button");

				if (activeSlide === 0) {
					// First slide, set opacity to 0.5
					leftButtonContainer.style.opacity = 0.5;
					leftButton.disabled = true;
				} else {
					// Not the first slide, set opacity to 1
					leftButtonContainer.style.opacity = 1;
					leftButton.disabled = false;
				}

				if (activeSlide === totalSlides - 1) {
					// Last slide, set opacity to 0.5
					rightButtonContainer.style.opacity = 0.5;
					rightButton.disabled = true;
				} else {
					// Not the last slide, set opacity to 1
					rightButtonContainer.style.opacity = 1;
					rightButton.disabled = false;
				}
			},
		},

		navigation: {
			prevEl: ".hero__prev",
			nextEl: ".hero__next",
		},
		breakpoints: {
			320: {
				slidesPerView: 1.1,
				spaceBetween: 20,
				pagination: {
					el: ".swiper-pagination--mobile",
					type: "bullets",
					clickable: true,
				},
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 0,

				pagination: {
					el: ".swiper-pagination--desktop",
					type: "bullets",
					clickable: true,
					// title sidebar
					renderBullet: function (index, className) {
						var names = [];
						$(".swiper-wrapper .swiper-slide").each(function () {
							var title = $(this).data("title");
							names.push(title);
						});

						return (
							'<span class="' + className + '">' + names[index] + "</span>"
						);
					},
				},
			},
		},
	});
};

export default heroSlider;
